import React, { useState, useEffect, useContext } from "react";
import {
  Container,
  Typography,
  Box,
  Divider,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  InputLabel,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import { ContextSession } from "../../../services/ContextSession";
import CryptoJS from "crypto-js";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const VerSolConstanciaAsignador = () => {
  const [loading, setLoading] = useState(false);
  const [solicitudData, setSolicitudData] = useState(null);
  const [error, setError] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [consimageUrl, setConsImageUrl] = useState(null);
  let sessi = useContext(ContextSession);
  const SolicitudID = sessi.getVariable("IDsolConstancia");
  const [errorArchivo, setErrorArchivo] = useState("");
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [errores, setErrores] = useState({});
  const [dialogSuccessOpen, setDialogSuccessOpen] = useState(false);
  const navigate = useNavigate();
  const [form, setForm] = useState({
    constancia: null,
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [comproimageUrl, setComproImageUrl] = useState(null);

  const [dialogOpenEntrega, setDialogOpenEntrega] = useState(false);
  const [openDialogEntrega, setOpenDialogEntrega] = useState(false);
  const [constanciaEscaneadaEntrega, setConstanciaEscaneadaEntrega] =
    useState(null);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmarEnvio = () => {
    handleEnviarConstanciaFisica();
    setOpenDialog(false);
  };

  const handleOpenDialogEntrega = () => {
    setConstanciaEscaneadaEntrega(null);
    setOpenDialogEntrega(true);
  };

  const handleCloseDialogEntrega = () => {
    setConstanciaEscaneadaEntrega(null);
    setOpenDialogEntrega(false);
  };

  const handleConfirmarEnvioEntrega = () => {
    if (!constanciaEscaneadaEntrega) {
      setErrorArchivo("Debe adjuntar la constancia escaneada.");
      return;
    }
    handleEntregaConstanciaFisica();
    setOpenDialogEntrega(false);
  };

  const tiposConstancia = {
    1: "HISTORIAL DE COTIZACIONES",
    2: "RAZONADA",
    3: "SALDOS PROYECTADOS",
    4: "NO TENER PRÉSTAMO ACTIVO",
    5: "TRÁMITE EMBAJADA",
  };

  const obtenerNombreOficina = (idOficina) => {
    const oficinas = {
      1: "Tegucigalpa",
      2: "San Pedro Sula",
      3: "La Ceiba",
      4: "Choluteca",
      5: "Santa Rosa de Copán",
      6: "Santa Bárbara",
      7: "Juticalpa",
    };

    return oficinas[idOficina] || idOficina;
  };

  // const dominio = "http://172.20.7.10:8082";
  const dominio = "https://be.injupemp.gob.hn:8443";
  // const dominio = "http://127.0.0.1:8000";

  // Añade esta función fuera del componente
  function cleanBase64(base64Str) {
    if (!base64Str) return "";
    if (base64Str.startsWith('"') && base64Str.endsWith('"')) {
      base64Str = base64Str.slice(1, -1);
    }
    return base64Str.replace(/(\r\n|\n|\r)/gm, "").replace(/\s+/g, "");
  }

  useEffect(() => {
    const fetchData = async () => {
      if (!SolicitudID) return;
      setLoading(true);
      setError(null);

      try {
        const secretKey =
          "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
        const queryString = `IdConstancia=${SolicitudID}`;
        const signature = CryptoJS.HmacSHA256(
          queryString,
          secretKey
        ).toString();

        const response = await fetch(
          `${dominio}/api/ConstanciaPag/Constancia/?IdConstancia=${SolicitudID}`,
          {
            // const response = await fetch(
            //   `http://172.20.7.10:8082/api/ConstanciaPag/Constancia/?IdConstancia=${SolicitudID}`,
            //   {
            headers: {
              "X-Signature": signature,
            },
          }
        );

        if (!response.ok)
          throw new Error("Error al obtener los datos de la solicitud");

        const data = await response.json();
        setSolicitudData(data);

        // Procesar imagen Base64 si existe
        // Procesar PDF Base64 si existe
        if (data.CopiaDNI) {
          const base64Pdf = cleanBase64(data.CopiaDNI);
          if (base64Pdf.length > 20) {
            setImageUrl(`data:application/pdf;base64,${base64Pdf}`);
          }
        }

        if (data.CopiaConstancia) {
          const base64Pdf2 = cleanBase64(data.CopiaConstancia);
          if (base64Pdf2.length > 20) {
            setConsImageUrl(`data:application/pdf;base64,${base64Pdf2}`);
          }
        }

        if (data.comprobante) {
          const base64Pdf2 = cleanBase64(data.comprobante);
          if (base64Pdf2.length > 20) {
            setComproImageUrl(`data:application/pdf;base64,${base64Pdf2}`);
          }
        }
      } catch (err) {
        console.error("Error al cargar datos:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [SolicitudID]);

  const formatDate = (dateString) => {
    if (!dateString) return "No especificada";
    const date = new Date(dateString);
    return date.toLocaleDateString() + " " + date.toLocaleTimeString();
  };

  const getEstadoText = (estadoId) => {
    const estados = {
      1: "Pendiente",
      2: "Pagada",
      3: "Emitida",
      4: "Rechazada",
    };
    return estados[estadoId] || `Desconocido (ID: ${estadoId})`;
  };

  const handleFile = (e) => {
    const file = e.target.files[0];
    const isValid =
      file && file.size <= 5 * 1024 * 1024 && /\.(pdf)$/i.test(file.name);

    if (isValid) {
      setForm({ ...form, constancia: file });
      setErrorArchivo("");

      // Crear URL de vista previa
      const fileUrl = URL.createObjectURL(file);
      setPreviewUrl(fileUrl);
    } else {
      setErrorArchivo(
        "Archivo inválido. Solo se permiten JPG, PNG, JPEG o PDF hasta 5MB."
      );
      setForm({ ...form, constancia: null });
      setPreviewUrl(null);
    }
  };

  const filas =
    solicitudData && solicitudData.solicitud
      ? [
          {
            label: "Tipo Constancia",
            value:
              tiposConstancia[solicitudData.solicitud.fk_id_constancia] ||
              "No especificado",
          },
          {
            label: "Número de Recibo",
            value: solicitudData.solicitud.numero_recibo || "No especificado",
          },
          {
            label: "Estado",
            value: getEstadoText(solicitudData.solicitud.fk_id_estado),
          },
          { label: "Monto", value: `L. ${solicitudData.solicitud.monto}` },
          {
            label: "Detalle",
            value: solicitudData.solicitud.detalle_solicitud,
          },
          {
            label: "Fecha de Registro",
            value: formatDate(solicitudData.solicitud.fecha_registro),
          },
          {
            label: "Fecha de Pago",
            value: formatDate(solicitudData.solicitud.fecha_pagada),
          },
          {
            label: "Fecha de Emisión",
            value: formatDate(solicitudData.solicitud.fecha_emitida),
          },
          ...(solicitudData.solicitud.LugarResidencia
            ? [
                {
                  label: "Lugar de Residencia",
                  value: solicitudData.solicitud.LugarResidencia,
                },
              ]
            : []),

          ...(solicitudData.solicitud.FKIdOficina
            ? [
                {
                  label: "Oficina de Entrega",
                  value: obtenerNombreOficina(
                    solicitudData.solicitud.FKIdOficina
                  ),
                },
              ]
            : []),
          ...(solicitudData.solicitud.fecha_recepcion
            ? [
                {
                  label: "Fecha de Recepción",
                  value: formatDate(solicitudData.solicitud.fecha_recepcion),
                },
              ]
            : []),

          ...(solicitudData.solicitud.fecha_entregada
            ? [
                {
                  label: "Fecha de Entrega",
                  value: formatDate(solicitudData.solicitud.fecha_entregada),
                },
              ]
            : []),
        ]
      : [];

  const filas2 =
    solicitudData && solicitudData.solicitud
      ? [
          { label: "DNI", value: solicitudData.DatosUsuario.DNI },
          { label: "Nombre", value: solicitudData.DatosUsuario.NombreCompleto },
          { label: "Teléfono", value: solicitudData.DatosUsuario.Telefono },
          {
            label: "Estado Solicitante",
            value: solicitudData.DatosUsuario.estado,
          },
        ]
      : [];

  const validarFormulario = () => {
    const nuevosErrores = {};

    if (!form.constancia) {
      nuevosErrores.constancia = "Debe adjuntar la constancia médica";
    }

    setErrores(nuevosErrores);
    if (Object.keys(nuevosErrores).length > 0) {
      setDialogOpen(true);
      return false;
    }

    return true;
  };

  const handleEnviarConstancia = async () => {
    if (!validarFormulario()) return; // Si hay errores, muestra el Dialog de errores

    setLoading(true);
    setErrorArchivo("");
    try {
      // FormData con los datos requeridos
      const formData = new FormData();
      formData.append("IdConstancia", SolicitudID);
      formData.append("Constancia", form.constancia);

      // Firma HMAC igual que tu GET
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdConstancia=${SolicitudID}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString();

      // POST con fetch
      const response = await fetch(`${dominio}/api/ConstanciaPag/Adjuntar/`, {
        //  const response = await fetch("http://172.20.7.10:8082/api/ConstanciaPag/Adjuntar/", {
        method: "POST",
        body: formData,
        headers: {
          "X-Signature": signature,
          // Importante: NO pongas Content-Type, fetch lo maneja con FormData
        },
      });

      if (!response.ok) {
        throw new Error("Error al enviar la constancia");
      }

      // Mostrar Dialog de éxito
      setDialogSuccessOpen(true);
      setForm({ constancia: null });
      setPreviewUrl(null);
    } catch (err) {
      setErrorArchivo(
        err.message || "Ocurrió un error al adjuntar la constancia."
      );
    } finally {
      setLoading(false);
    }
  };

  // ENVIAR CONSTANCIA FISICA

  const handleEnviarConstanciaFisica = async () => {
    // if (!validarFormulario()) return; // Si hay errores, muestra el Dialog de errores

    setLoading(true);
    setErrorArchivo("");
    try {
      // FormData con los datos requeridos
      const formData = new FormData();
      formData.append("IdSolicitud", SolicitudID);

      // Firma HMAC igual que tu GET
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdSolicitud=${SolicitudID}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString();

      // POST con fetch
      const response = await fetch(
        `${dominio}/api/ConstanciaPag/EnviarOficina/`,
        {
          //  const response = await fetch("http://172.20.7.10:8082/api/ConstanciaPag/Adjuntar/", {
          method: "PATCH",
          body: formData,
          headers: {
            "X-Signature": signature,
            // Importante: NO pongas Content-Type, fetch lo maneja con FormData
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al enviar la constancia");
      }

      // Mostrar Dialog de éxito
      setDialogSuccessOpen(true);
      setForm({ constancia: null });
      setPreviewUrl(null);
    } catch (err) {
      setErrorArchivo(
        err.message || "Ocurrió un error al enviar la constancia."
      );
    } finally {
      setLoading(false);
    }
  };

  // ENTREGAR CONSTANCIA FISICA

  const handleEntregaConstanciaFisica = async () => {
    // if (!validarFormulario()) return; // Si hay errores, muestra el Dialog de errores

    setLoading(true);
    setErrorArchivo("");
    const username = sessi.sessionData.username;
    try {
      // FormData con los datos requeridos
      const formData = new FormData();
      formData.append("IdSolicitud", SolicitudID);
      formData.append("Usuario", username);
      formData.append("ConstanciaEscaneadaDigital", constanciaEscaneadaEntrega);

      // Firma HMAC igual que tu GET
      const secretKey =
        "django-insecure-8mo+j636(t*_cj&s&&3$7@*vwsk#yyl0u5fbv-v*^-)e!y&k#8";
      const queryString = `IdSolicitud=${SolicitudID}`;
      const signature = CryptoJS.HmacSHA256(queryString, secretKey).toString();

      // POST con fetch
      const response = await fetch(
        `${dominio}/api/ConstanciaPag/MarcarEntregada/Oficina/`,
        {
          //  const response = await fetch("http://172.20.7.10:8082/api/ConstanciaPag/Adjuntar/", {
          method: "PATCH",
          body: formData,
          headers: {
            "X-Signature": signature,
            // Importante: NO pongas Content-Type, fetch lo maneja con FormData
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al entregar la constancia");
      }

      // Mostrar Dialog de éxito
      setDialogSuccessOpen(true);
      setForm({ constancia: null });
      setConstanciaEscaneadaEntrega(null);
      setPreviewUrl(null);
    } catch (err) {
      setErrorArchivo(
        err.message || "Ocurrió un error al entregar la constancia."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Container maxWidth="lg" style={{ marginTop: 20 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          fontWeight={"bold"}
        >
          Detalle de Solicitud de Constancia #{SolicitudID}
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}

        {solicitudData && (
          <>
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Información de la Solicitud
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {filas.map((fila, idx) => (
                      <TableRow
                        key={fila.label}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#f5f5f5" : "#fff", // Gris suave y blanco
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ fontWeight: "bold", fontSize: "1.18rem" }}
                        >
                          {fila.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1.18rem" }}>
                          {fila.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Divider sx={{ mb: 2 }} />
            <Box sx={{ mb: 4 }}>
              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Información del Solicitante
              </Typography>
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {filas2.map((fila, idx) => (
                      <TableRow
                        key={fila.label}
                        sx={{
                          backgroundColor: idx % 2 === 0 ? "#f5f5f5" : "#fff", // Gris suave y blanco
                        }}
                      >
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{ fontWeight: "bold", fontSize: "1.18rem" }}
                        >
                          {fila.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "1.18rem" }}>
                          {fila.value}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            <Box sx={{ mb: 4 }}>
              <Divider sx={{ mb: 2 }} />

              <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                Copia de DNI
              </Typography>
              {imageUrl ? (
                <Box
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: 2,
                    overflow: "hidden",
                    width: "100%",
                    maxWidth: "1200px", // <-- Cambia aquí el ancho
                    mx: "auto",
                    minHeight: "650px", // <-- Más alto el iframe
                    boxShadow: 2,
                  }}
                >
                  <iframe
                    src={imageUrl}
                    title="Copia de DNI PDF"
                    width="100%"
                    height="650px" // <-- Más alto el visor PDF
                    style={{ border: "none", display: "block" }}
                  ></iframe>
                  <Box sx={{ textAlign: "center", mt: 2 }}>
                    <a
                      href={imageUrl}
                      download="Copia_DNI.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Descargar Copia de DNI (PDF)
                    </a>
                  </Box>
                </Box>
              ) : (
                <Alert severity="info">
                  No se encontró copia de DNI adjunta
                </Alert>
              )}
            </Box>

            {solicitudData.CopiaConstancia && 1 === 2 && (
              <Box>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                  Copia de Constancia de la institución donde laboró
                </Typography>
                {consimageUrl ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "hidden",
                      width: "100%",
                      maxWidth: "1200px", // <-- Cambia aquí el ancho
                      mx: "auto",
                      minHeight: "650px", // <-- Más alto el iframe
                      boxShadow: 2,
                    }}
                  >
                    <iframe
                      src={consimageUrl}
                      title="Copia de DNI PDF"
                      width="100%"
                      height="650px" // <-- Más alto el visor PDF
                      style={{ border: "none", display: "block" }}
                    ></iframe>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <a
                        href={consimageUrl}
                        download="Copia_DNI.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Descargar Copia de Constancia (PDF)
                      </a>
                    </Box>
                  </Box>
                ) : (
                  <Alert severity="info">
                    No se encontró copia de constancia adjunta
                  </Alert>
                )}
              </Box>
            )}

            {solicitudData.comprobante && (
              <Box>
                <Divider sx={{ mb: 2 }} />
                <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                  Comprobante de Entrega
                </Typography>
                {comproimageUrl ? (
                  <Box
                    sx={{
                      border: "1px solid #ccc",
                      borderRadius: 2,
                      overflow: "hidden",
                      width: "100%",
                      maxWidth: "1200px", // <-- Cambia aquí el ancho
                      mx: "auto",
                      minHeight: "650px", // <-- Más alto el iframe
                      boxShadow: 2,
                    }}
                  >
                    <iframe
                      src={comproimageUrl}
                      title="Comprobante de Entrega PDF"
                      width="100%"
                      height="650px" // <-- Más alto el visor PDF
                      style={{ border: "none", display: "block" }}
                    ></iframe>
                    <Box sx={{ textAlign: "center", mt: 2 }}>
                      <a
                        href={comproimageUrl}
                        download="Comprobante_Entrega.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Descargar Comprobante (PDF)
                      </a>
                    </Box>
                  </Box>
                ) : (
                  <Alert severity="info">No se encontró comprobante</Alert>
                )}
              </Box>
            )}

            {!solicitudData.constancia &&
              solicitudData.solicitud.operacionesAsigno !== null &&
              solicitudData.solicitud.fk_id_constancia === 2 &&
              1 === 2 && (
                <>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                    Adjuntar Constancia
                  </Typography>

                  <Box mt={2}>
                    <Typography
                      mt={1}
                      color="textSecondary"
                      sx={{ textAlign: "justify", fontSize: "1.1rem" }}
                    >
                      Adjunte la constancia firmada y sellada en formato PDF la
                      cual será enviada al solicitante.
                    </Typography>

                    <Button
                      variant="outlined"
                      component="label"
                      startIcon={<UploadFileIcon />}
                      sx={{
                        borderRadius: 2,
                        fontSize: "1.1rem",
                        textTransform: "none",
                        borderColor: "#89CFE0",
                        color: "#2C3E50",
                        backgroundColor: "#fff",
                        "&:hover": {
                          backgroundColor: "#f0f8ff",
                          borderColor: "#62b0c9",
                        },
                        marginTop: 2,
                      }}
                    >
                      Seleccionar Archivo
                      <input
                        type="file"
                        accept=".pdf"
                        hidden
                        onChange={handleFile}
                      />
                    </Button>

                    {form.constancia && (
                      <Typography mt={1} variant="body2" color="textSecondary">
                        Archivo seleccionado:{" "}
                        <strong>{form.constancia.name}</strong>
                      </Typography>
                    )}

                    {errorArchivo && (
                      <Alert severity="error" sx={{ mt: 1 }}>
                        {errorArchivo}
                      </Alert>
                    )}

                    {previewUrl && (
                      <Box
                        mt={2}
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          overflow: "hidden",
                          mx: "auto",
                        }}
                      >
                        <iframe
                          src={previewUrl}
                          title="Vista previa PDF"
                          width="100%"
                          height="700px"
                          style={{ border: "none" }}
                          allow="fullscreen"
                        />
                      </Box>
                    )}

                    <Button
                      variant="contained"
                      onClick={handleEnviarConstancia}
                      sx={{
                        mt: 3,
                        mb: 4,
                        fontSize: "1.1rem",
                        display: "block",
                        mx: "auto",
                        fontWeight: "bold",
                        backgroundColor: "#6bb5c6",
                        "&:hover": {
                          backgroundColor: "#4e838fff", // Un tono un poco más oscuro para el hover
                        },
                      }}
                    >
                      Enviar Constancia
                    </Button>
                  </Box>
                </>
              )}

            {solicitudData.solicitud.operacionesAsigno !== null &&
              solicitudData.solicitud.fk_id_constancia !== 2 &&
              solicitudData.solicitud.enviadaOficina === false &&
              solicitudData.solicitud.oficinaEntregaParticipante === false &&
              1 === 2 && (
                <>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                    Enviar Constancia
                  </Typography>

                  <Box mt={2}>
                    <Typography
                      mt={1}
                      color="textSecondary"
                      sx={{ textAlign: "justify", fontSize: "1.1rem" }}
                    >
                      Al confirmar en el botón{" "}
                      <strong>ENVIAR CONSTANCIA</strong>, tu solicitud será
                      enviada al encargado responsable de entregar la constancia
                      segun la oficina que selecciono participante.
                    </Typography>

                    <Button
                      variant="contained"
                      onClick={handleOpenDialog}
                      sx={{
                        mt: 3,
                        mb: 4,
                        fontSize: "1.1rem",
                        display: "block",
                        mx: "auto",
                        fontWeight: "bold",
                        backgroundColor: "#6bb5c6",
                        "&:hover": {
                          backgroundColor: "#4e838fff",
                        },
                      }}
                    >
                      Enviar Constancia
                    </Button>
                  </Box>

                  {/* Dialog de confirmación */}
                  <Dialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title" fontWeight="bold">
                      Confirmar envío de constancia
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        ¿Estás seguro de que deseas enviar la constancia? Esta
                        acción no se puede deshacer y la solicitud será enviada
                        al encargado responsable.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseDialog} color="primary">
                        Cancelar
                      </Button>
                      <Button
                        onClick={handleConfirmarEnvio}
                        color="primary"
                        autoFocus
                        variant="contained"
                      >
                        Confirmar Envío
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}

            {solicitudData.solicitud.operacionesAsigno !== null &&
              solicitudData.solicitud.fk_id_constancia !== 2 &&
              solicitudData.solicitud.enviadaOficina === false &&
              solicitudData.solicitud.oficinaEntregaParticipante === false &&
              1 === 2 && (
                <>
                  <Divider sx={{ mb: 2 }} />
                  <Typography variant="h5" gutterBottom fontWeight={"bold"}>
                    Entregar Constancia a Participante
                  </Typography>

                  <Box mt={2}>
                    <Typography
                      mt={1}
                      color="textSecondary"
                      sx={{ textAlign: "justify", fontSize: "1.1rem" }}
                    >
                      Al confirmar en el botón{" "}
                      <strong>ENTREGAR A PARTICIPANTE</strong>, tu solicitud
                      finalizara como emitida y entregada al participante.
                    </Typography>

                    <Button
                      variant="contained"
                      onClick={handleOpenDialogEntrega}
                      sx={{
                        mt: 3,
                        mb: 4,
                        fontSize: "1.1rem",
                        display: "block",
                        mx: "auto",
                        fontWeight: "bold",
                        backgroundColor: "#c04b4bff",
                        "&:hover": {
                          backgroundColor: "#8f4e4eff",
                        },
                      }}
                    >
                      ENTREGAR A PARTICIPANTE
                    </Button>
                  </Box>

                  {/* Dialog de confirmación */}
                  <Dialog
                    open={openDialogEntrega}
                    onClose={handleCloseDialogEntrega}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title" fontWeight="bold">
                      Confirmar entrega de constancia
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        ¿Estás seguro de que deseas entregar constancia? Esta
                        acción no se puede deshacer y la solicitud será
                        finalizada como emitida y entregada.
                      </DialogContentText>
                      <input
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        id="constancia-escaneada-entrega-asignador"
                        type="file"
                        style={{ display: "none" }}
                        onChange={(event) =>
                          setConstanciaEscaneadaEntrega(
                            event.target.files?.[0] || null
                          )
                        }
                      />
                      <label htmlFor="constancia-escaneada-entrega-asignador">
                        <Button
                          variant="outlined"
                          component="span"
                          fullWidth
                          startIcon={<UploadFileIcon />}
                          sx={{ mt: 2 }}
                        >
                          Adjuntar Constancia Escaneada
                        </Button>
                      </label>
                      {constanciaEscaneadaEntrega && (
                        <Typography
                          variant="body2"
                          sx={{ mt: 1, color: "text.secondary" }}
                        >
                          Archivo seleccionado:{" "}
                          {constanciaEscaneadaEntrega.name}
                        </Typography>
                      )}
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={handleCloseDialogEntrega}
                        color="primary"
                      >
                        Cancelar
                      </Button>
                      <Button
                        onClick={handleConfirmarEnvioEntrega}
                        color="primary"
                        autoFocus
                        variant="contained"
                        disabled={!constanciaEscaneadaEntrega || loading}
                      >
                        Confirmar Entrega
                      </Button>
                    </DialogActions>
                  </Dialog>
                </>
              )}
          </>
        )}
      </Container>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle textAlign={"center"}>
          Complete los siguientes campos:
        </DialogTitle>
        <DialogContent dividers>
          <ul>
            {Object.entries(errores).map(([campo, mensaje]) => (
              <li key={campo}>
                <Typography variant="body2">{mensaje}.</Typography>
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => setDialogOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#d32f2f",
              color: "white",
              "&:hover": {
                backgroundColor: "#b71c1c",
              },
              fontWeight: "bold",
              borderRadius: 2,
            }}
          >
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={dialogSuccessOpen}
        onClose={() => {
          setDialogSuccessOpen(false);
          navigate("/ListaSolicitudesConstanciasOP");
        }}
      >
        <DialogTitle textAlign="center">
          <CheckCircleIcon
            style={{
              color: "green",
              marginRight: "10px",
              verticalAlign: "middle",
            }}
          />
          ¡Constancia enviada con éxito!
        </DialogTitle>
        <DialogContent>
          <Typography align="center">
            La constancia ha sido enviada correctamente al solicitante.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            onClick={() => {
              setDialogSuccessOpen(false);
              navigate("/PortalDelParticipante/ListaSolicitudesConstanciasOP");
            }}
            variant="contained"
            sx={{
              backgroundColor: "green",
              color: "white",
              fontWeight: "bold",
              borderRadius: 2,
              px: 4,
              "&:hover": { backgroundColor: "#11af11ff" },
            }}
          >
            Aceptar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VerSolConstanciaAsignador;
